// /error/error-index.ts

// Импортируем ErrorLogger для использования в обертках
import { ErrorLogger } from '@/utils/error-logger';

// Экспорт констант ошибок
export { 
  ERROR_CODES, 
  ERROR_MESSAGES,
  ERROR_TRANSLATION_KEYS 
} from './error-constants';

// Экспорт из файла error-handlers.ts
export { 
  displayErrorNotification,
  isNetworkError,
  isValidationError,
  getErrorTranslationKey,
  ErrorDisplay
} from './error-handlers';

// Экспорт класса ErrorLogger
export { ErrorLogger } from '@/utils/error-logger';

// Обертки для методов ErrorLogger
export const logError = (error: any, source: string) => ErrorLogger.logError(error, source);
export const markResolved = (errorId: string) => ErrorLogger.markResolved(errorId);

// Экспорт из файла error-utils.ts
export {
  getErrorMessage,
  getErrorMessageStatic,
  shouldRetry
} from './error-utils';